import { Component, ReactNode } from 'react'
import { ErrorBoundaryProps, ErrorBoundaryState } from './ErrorBoundary.types'
import ErrorFallback from './ErrorFallback'

/**
 * Catches render errors anywhere below it and shows a fallback instead of
 * unmounting the whole app. Add a `componentDidCatch` method to forward errors
 * to a monitoring service (e.g. Sentry) once one is configured.
 */
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? <ErrorFallback />
    }
    return this.props.children
  }
}
